import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";
import { vpnManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";

export interface postVPNCancelSupportSessionDto {
  namespace: string;
  id: string;
}

export const postVPNCancelSupportSession = async (
  payload: postVPNCancelSupportSessionDto,
) => {
  const { namespace, id } = payload;

  const url = vpnManagerUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.post(
      `${url}/api/v1/ns/${namespace}/support-sessions/${id}/cancel`,
      {},
      { headers },
    );

    return response?.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to cancel support session. Please try again later.",
      );
    } else {
      throw new Error(
        "An unexpected error occurred while cancelling support session.",
      );
    }
  }
};
